import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  type DisplayRowId,
  type ScrollHash,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { type DisplayRowItem } from '~/utils'

import { hiddenRowIdsAtom } from '../atoms'

import { useFiveSegmentsBrandsData } from './useFiveSegmentsBrandsData'
import { useNineSegmentsBrandsData } from './useNineSegmentsBrandsData'

export const useDisplayRowItem = (
  tableId: ScrollHash,
): DisplayRowItem<DisplayRowId>[] => {
  const hiddenRowIds = useAtomValue(hiddenRowIdsAtom)
  const { t } = useTranslation()

  const fiveBrandsData = useFiveSegmentsBrandsData()
  const nineBrandsData = useNineSegmentsBrandsData()

  return React.useMemo(
    () => [
      {
        label: t('brand_name_2'),
        subItems: {
          '5segs': fiveBrandsData,
          '9segs': nineBrandsData,
        }[tableId].map((brand) => ({
          id: brand.brandId,
          isVisible: !hiddenRowIds.includes(brand.brandId),
          label: brand.brandName,
        })),
      },
      {
        label: t('core_metrics'),
        subItems: [
          {
            id: 'average',
            isVisible: !hiddenRowIds.includes('average'),
            label: t('average'),
          },
          {
            id: 'max',
            isVisible: !hiddenRowIds.includes('max'),
            label: t('maximum_value'),
          },
        ],
      },
    ],
    [fiveBrandsData, hiddenRowIds, nineBrandsData, tableId, t],
  )
}
